import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ContactSection({ onOpenForm }) {
  return (
    <section id="contact" data-testid="contact-section" className="py-20 md:py-32 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.2em] text-[#1E3A8A] mb-4">
            Contact Us
          </span>
          <h2
            data-testid="contact-heading"
            className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0F172A] tracking-tight mb-4"
          >
            Get in Touch with Our Trademark Experts
          </h2>
          <p className="text-[#475569] text-base sm:text-lg max-w-3xl mx-auto leading-relaxed">
            Have questions about trademark registration or ready to get started? Our team of experienced trademark professionals is here to help. Reach out to us using any of the contact methods below, or click the button to start your trademark registration today. We respond to all inquiries within 24 hours during business days.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {/* Email */}
          <div
            data-testid="contact-card-email"
            className="bg-white border border-slate-200 rounded-lg p-7 text-center hover:shadow-md transition-all duration-300"
          >
            <div className="w-12 h-12 rounded-full bg-[#1E3A8A]/10 flex items-center justify-center mx-auto mb-4">
              <Mail className="w-5 h-5 text-[#1E3A8A]" />
            </div>
            <h3 className="font-heading text-base font-semibold text-[#0F172A] mb-2">Email Us</h3>
            <a
              href="mailto:info@trademarkofficers.us"
              data-testid="contact-email-link"
              className="text-[#2563EB] text-sm font-medium hover:underline"
            >
              info@trademarkofficers.us
            </a>
            <p className="text-[#475569] text-xs mt-2">
              Send us your questions or trademark inquiries anytime. Our team monitors emails during business hours and responds promptly.
            </p>
          </div>

          {/* Phone */}
          <div
            data-testid="contact-card-phone"
            className="bg-white border border-slate-200 rounded-lg p-7 text-center hover:shadow-md transition-all duration-300"
          >
            <div className="w-12 h-12 rounded-full bg-[#1E3A8A]/10 flex items-center justify-center mx-auto mb-4">
              <Phone className="w-5 h-5 text-[#1E3A8A]" />
            </div>
            <h3 className="font-heading text-base font-semibold text-[#0F172A] mb-2">Call Us</h3>
            <a
              href="tel:+11231234567"
              data-testid="contact-phone-link"
              className="text-[#2563EB] text-sm font-medium hover:underline"
            >
              +1 (123) 123-4567
            </a>
            <p className="text-[#475569] text-xs mt-2">
              Speak directly with a trademark specialist. We are available to answer your questions and guide you through the registration process.
            </p>
          </div>

          {/* Address */}
          <div
            data-testid="contact-card-address"
            className="bg-white border border-slate-200 rounded-lg p-7 text-center hover:shadow-md transition-all duration-300"
          >
            <div className="w-12 h-12 rounded-full bg-[#1E3A8A]/10 flex items-center justify-center mx-auto mb-4">
              <MapPin className="w-5 h-5 text-[#1E3A8A]" />
            </div>
            <h3 className="font-heading text-base font-semibold text-[#0F172A] mb-2">Visit Us</h3>
            <p className="text-[#475569] text-sm">
              11040 Santa Monica Blvd #310,
              <br />
              Los Angeles, CA 90025
            </p>
            <p className="text-[#475569] text-xs mt-2">
              Our office is conveniently located in the heart of Los Angeles for in-person consultations.
            </p>
          </div>

          {/* Hours */}
          <div
            data-testid="contact-card-hours"
            className="bg-white border border-slate-200 rounded-lg p-7 text-center hover:shadow-md transition-all duration-300"
          >
            <div className="w-12 h-12 rounded-full bg-[#1E3A8A]/10 flex items-center justify-center mx-auto mb-4">
              <Clock className="w-5 h-5 text-[#1E3A8A]" />
            </div>
            <h3 className="font-heading text-base font-semibold text-[#0F172A] mb-2">Business Hours</h3>
            <p className="text-[#475569] text-sm">
              Mon &ndash; Fri: 9:00 AM &ndash; 6:00 PM (PST)
              <br />
              Sat: 10:00 AM &ndash; 2:00 PM (PST)
            </p>
            <p className="text-[#475569] text-xs mt-2">
              Online inquiries are reviewed and responded to within 24 business hours.
            </p>
          </div>
        </div>

        <div className="text-center">
          <Button
            onClick={onOpenForm}
            data-testid="contact-cta-btn"
            className="bg-[#1E3A8A] hover:bg-[#1E40AF] text-white h-12 px-8 font-semibold rounded-lg hover:scale-[1.02] active:scale-[0.98] transition-all"
          >
            Protect My Brand
          </Button>
        </div>
      </div>
    </section>
  );
}
